import React, { useState, useEffect } from "react";
import { IoCloseOutline } from "react-icons/io5";
import { motion } from "framer-motion";
import {
  serviceUpdateUserUsingUserId
} from "../services/profileApi";
import { editPatientValidation } from "../utils/validations/editPatientValidation";
import * as Yup from "yup";
import {
  calculateAgeR,
  calculateDateOfBirthFromAgeR,
} from "../utils/commonUtils";
import { showToast } from "../utils/toastUtils";
import { FaSpinner } from "react-icons/fa";
import dayjs from "dayjs";
import AntDatePicker from "./antDatepicker";
const EditPatientModal = ({
  patient,
  isOpen,
  onClose,
  fetchData,
}) => {

  const [patientDetails, setPatientDetails] = useState({});
  const [patientContactNumber, setPatientContactNumber] = useState("");
  const [errorMessage, setErrorMessage] = useState({});
  const [name, setName] = useState("");
  const [age, setAge] = useState("");
  const [gender, setGender] = useState("");
  const [date_of_birth, setBirthDate] = useState("");
  const [isSubmitting, setIsSubmitting] = useState(false);

  const handleEditPatientSubmit = async (patientData) => {
    const {
      name,
      age,
      gender,
      patientContactNumber,
      patientDetails,
      date_of_birth,
    } = patientData;
    try {
      setIsSubmitting(true);
      let user_id = patientData?.patientDetails?.user_id;
      patientData.userId = user_id;
      patientData.dateOfBirth = date_of_birth;
      let nameArray = name.split(' '); // Split the full name into an array of words
      if (nameArray.length > 1) {
        patientData.lastName = nameArray.pop(); // Remove and get the last word as the last name
        patientData.firstName = nameArray.join(' '); // Join the remaining words as the first name
      } else {
        patientData.firstName = nameArray[0]; // Assign the single element as the first name
        patientData.lastName = null; // Set last name to null
      }
      patientData.primary_phone_number = patientContactNumber;
      await editPatientValidation.validate(
        {
          name,
          age,
          date_of_birth,
          patientContactNumber,
          patientDetails,
          gender,
        },
        { abortEarly: false }
      );
      const response = await serviceUpdateUserUsingUserId(patientData);
      if (response?.status) {
        showToast(response.message, "success");
        fetchData();
      } else {
        console.error("Failed to create appointment for new patient");
        showToast(response.message, "error");
      }
      handleClose();
    } catch (error) {
      if (error instanceof Yup.ValidationError) {
        // Handle the validation error
        const validationErrors = {};
        error.inner.forEach((err) => {
          validationErrors[err.path] = err.message;
        });
        setErrorMessage(validationErrors);
      } else {
        console.error("Network error:", error);
        setErrorMessage({ customError: "Network error. Please try again." });
      }
    } finally {
      setIsSubmitting(false);
    }
  };

  const handleLocalSubmit = async (e) => {
    e.preventDefault();
    await handleEditPatientSubmit({
      name,
      age,
      gender,
      patientContactNumber,
      patientDetails: patient,
      date_of_birth,
    });
  };

  const resetForm = () => {
    setName("");
    setAge("");
    setGender("");
    setPatientContactNumber("");
    setPatientDetails({});
    setBirthDate("");
    setErrorMessage({});
  };

  const handleClose = () => {
    resetForm();
    onClose();
  };

  const CalculateAgeFromDate = (date) => {
    if (date) {
      setBirthDate(dayjs(date).startOf('day').format("YYYY-MM-DD"));
      let localAge = calculateAgeR(date);
      setAge(localAge);
    }
  };

  const handleChangeAge = (event) => {
    if (isNaN(event.target.value)) {
      setAge("");
      showToast("Only number allowed", "error");
    } else {
      if (event.target.value < 1) {
        let localDob = calculateDateOfBirthFromAgeR(age);
        setBirthDate(dayjs(localDob).format('YYYY-MM-DD'));
        CalculateAgeFromDate(dayjs(localDob).format('YYYY-MM-DD'))
      }
      let localDob = calculateDateOfBirthFromAgeR(age);
      setBirthDate(dayjs(localDob).format('YYYY-MM-DD'));
    }
  };

  // useEffect to autofill the form fields when patient changes
  useEffect(() => {
    if (patient) {
      setName(patient.name || "");
      setAge(patient.age || "");
      setGender(patient.gender || "");
      setBirthDate(patient.date_of_birth ? dayjs(patient.date_of_birth).format("YYYY-MM-DD") : "");
      setPatientContactNumber(patient.primary_phone_number || "");
    }
  }, [patient]);

  return (
    <>
      {isOpen && (
        <div className="fixed inset-0 bg-black bg-opacity-50 overflow-y-auto h-full w-full z-50">
          <div className="relative top-0 lg:top-20 mx-auto p-5 border shadow-lg rounded-md bg-white  w-full h-full lg:h-auto lg:w-[550px]">
            <div className="mt-2">
              <div className=" mb-5 flex justify-between">
                <span className="text-xl font-semibold text-gray-800 ">
                  {" "}
                  Edit Patient
                </span>
                <button
                  onClick={handleClose}
                  className=" absolute right-3 top-3 text-gray-600 bg-gray-100 hover:bg-gray-300 focus:ring-4 focus:outline-none focus:ring-gray-200  hover:text-gray-800 px-0 w-10 h-10 inline-flex justify-center items-center rounded-full text-2xl m-1.5"
                >
                  <IoCloseOutline />
                  <span className="sr-only">Icon description</span>
                </button>
              </div>
              <div className="flex  ">
                <motion.div
                >
                </motion.div>
              </div>
              <div className=" border mt-[-1px]">
                <motion.div
                  className="w-full"
                  initial={{ opacity: 0, x: 0, overflow: "hidden" }}
                  animate={{ opacity: 1, x: 0, overflow: "visible" }}
                  transition={{ duration: 0.3 }}
                >
                  <form
                    className="space-y-6 p-6 px-6 "
                    onSubmit={handleLocalSubmit}
                  >
                    <div className="grid grid-cols-2 gap-4">
                      <div className="col-span-2">
                        <label
                          htmlFor="mobile"
                          className="block text-gray-700 text-sm mb-1"
                        >
                          Mobile Number
                        </label>
                        <input
                          type="text"
                          id="patientContactNumber"
                          value={patientContactNumber}
                          onChange={(e) => setPatientContactNumber(e.target.value)}
                          // required
                          disabled={
                            patientDetails &&
                            patientDetails.patient_id &&
                            patientDetails.full_name
                          }
                          className="w-full px-3 py-2 border rounded-md text-gray-700"
                        />

                        <div className=" text-sm text-red-500">
                          {errorMessage?.patientContactNumber}
                        </div>
                      </div>
                      <div className="col-span-2 flex items-center w-full ">
                        <div className="w-9/12 ml-2">
                          <label
                            htmlFor="name"
                            className="block text-gray-700 text-sm mb-1"
                          >
                            Patient Name
                          </label>
                          <input
                            type="text"
                            id="name"
                            value={name}
                            onChange={(e) => setName(e.target.value)}
                            // required
                            disabled={
                              patientDetails &&
                              patientDetails.patient_id &&
                              patientDetails.full_name
                            }
                            className="w-full px-3 py-2 border rounded-md text-gray-700"
                          />
                          <div className=" text-sm text-red-500">
                            {errorMessage?.name}
                          </div>
                        </div>
                      </div>
                      <div className="col-span-2">
                        <label
                          htmlFor="gender"
                          className="block text-gray-700 text-sm mb-1"
                        >
                          Gender
                        </label>
                        <div className="flex space-x-4">
                          <button
                            type="button"
                            disabled={
                              patientDetails &&
                              patientDetails.patient_id &&
                              patientDetails.gender
                            }
                            className={`px-4 py-2 rounded-md ${gender === "Male"
                              ? "bg-blue-500 text-white"
                              : "bg-gray-200 text-gray-700"
                              }`}
                            onClick={() => setGender("Male")}
                          >
                            Male
                          </button>
                          <button
                            type="button"
                            disabled={
                              patientDetails &&
                              patientDetails.patient_id &&
                              patientDetails.gender
                            }
                            className={`px-4 py-2 rounded-md ${gender === "Female"
                              ? "bg-blue-500 text-white"
                              : "bg-gray-200 text-gray-700"
                              }`}
                            onClick={() => setGender("Female")}
                          >
                            Female
                          </button>
                          <button
                            type="button"
                            disabled={
                              patientDetails &&
                              patientDetails.patient_id &&
                              patientDetails.gender
                            }
                            className={`px-4 py-2 rounded-md ${gender === "Other"
                              ? "bg-blue-500 text-white"
                              : "bg-gray-200 text-gray-700"
                              }`}
                            onClick={() => setGender("Other")}
                          >
                            Other
                          </button>
                        </div>
                        <div className=" text-sm text-red-500">
                          {errorMessage?.gender}
                        </div>
                      </div>
                      <div>
                        <label
                          htmlFor="age"
                          className="block text-gray-700 text-sm mb-1"
                        >
                          Age
                        </label>
                        <input
                          type="text"
                          id="age"
                          value={age}
                          onChange={(e) => setAge(e.target.value)}
                          onBlur={handleChangeAge}
                          disabled={
                            patientDetails &&
                            patientDetails.patient_id &&
                            patientDetails.age
                          }
                          className="w-full px-3 py-2 border rounded-md text-gray-700"
                        />
                      </div>

                      <div className="w-full  px-3">
                        <label className="block text-gray-700 text-sm mb-1">
                          Date of birth
                        </label>

                        <AntDatePicker
                          defaultValue={null}
                          placeholder="select date"
                          value={date_of_birth ? dayjs(date_of_birth) : ''}
                          onChange={(dateString) => CalculateAgeFromDate(dateString)}
                          disabledFutureDate={true}
                          disabled={
                            patientDetails &&
                            patientDetails.patient_id &&
                            patientDetails.gender
                          }
                        />
                        {errorMessage?.date_of_birth != "" && (
                          <div className=" text-red-500 text-sm">
                            {errorMessage?.date_of_birth}
                          </div>
                        )}
                      </div>

                      <div className="col-span-2">

                      </div>
                    </div>
                    <button
                      type="submit"
                      className="w-full bg-blue-500 text-white py-2 rounded-md hover:bg-blue-600 flex justify-center"
                      disabled={isSubmitting}
                    >
                      {isSubmitting ? (
                        <FaSpinner size={20} className="animate-spin" />
                      ) : (
                        "Edit Patient"
                      )}
                    </button>
                  </form>
                </motion.div>
              </div>
            </div>
          </div>
        </div>
      )}
    </>
  );
};
export default EditPatientModal;